import { 
  LOGIN_SUCCESS, 
  LOGIN_FAILURE, 
  LOGOUT, 
  REFRESH_TOKEN_SUCCESS, 
  ADMIN_LOGIN_SUCCESS, 
  ADMIN_LOGIN_FAILURE 
} from "../actions/auth";

// Utility function to safely parse JSON
function safelyParseJSON(item) {
  try {
    return JSON.parse(item);
  } catch (error) {
    return null; // Return null if parsing fails
  }
}

// Initial state with safe parsing
const initialState = {
  isAuthenticated: false,
  user: safelyParseJSON(localStorage.getItem("user")) || null,
  admin: safelyParseJSON(localStorage.getItem("admin")) || null,
  error: null,
};

export const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      localStorage.setItem("user", JSON.stringify(action.payload));
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload,
        error: null,
      };

    case ADMIN_LOGIN_SUCCESS:
      localStorage.setItem("admin", JSON.stringify(action.payload.admin));
      localStorage.setItem("adminToken", action.payload.token);
      return {
        ...state,
        isAuthenticated: true,
        admin: action.payload.admin,
        error: null,
      };

    case LOGIN_FAILURE:
    case ADMIN_LOGIN_FAILURE:
      return {
        ...state,
        isAuthenticated: false,
        user: null,
        admin: null,
        error: action.payload,
      };

    case LOGOUT:
      localStorage.removeItem("user");
      localStorage.removeItem("admin");
      localStorage.removeItem("adminToken");
      return {
        ...state,
        isAuthenticated: false,
        user: null,
        admin: null,
        error: null,
      };

    case REFRESH_TOKEN_SUCCESS:
      const updatedUser = { ...state.user, token: action.payload };
      localStorage.setItem("user", JSON.stringify(updatedUser));
      return {
        ...state,
        user: updatedUser,
      };

    default:
      return state;
  }
};
